/**
 * @file Timeline Mind component
 * @author Willem Jan Weitering
 */
import * as tslib_1 from "tslib";
import { OnInit } from '@angular/core';
import { TimelineItemBaseComponent } from '../timeline-item-base/timeline-item-base.component';
import { TimelineService } from '../timeline.service';
import { LocalisationService } from '../../core/localisation.service';
/**
 * This is a component that shows a 'What's on your mind' message from a user in the timeline.
 */
var TimelineItemMindComponent = /** @class */ (function (_super) {
    tslib_1.__extends(TimelineItemMindComponent, _super);
    /**
     * Constructs a TimelineMind Component
     */
    function TimelineItemMindComponent(timelineService, localisationService) {
        var _this = _super.call(this, timelineService, localisationService) || this;
        _this.timelineService = timelineService;
        _this.localisationService = localisationService;
        // Todo: use standard profile picture, this one has another background-color?!
        _this.fallbackProfilePictureUrl = require('../assets/images/resource-60x60-mind.png');
        return _this;
    }
    /**
     * Is called directly after the creation of this component
     */
    TimelineItemMindComponent.prototype.ngOnInit = function () {
    };
    return TimelineItemMindComponent;
}(TimelineItemBaseComponent));
export { TimelineItemMindComponent };
